import React, { useState } from "react";
import { FormHelperText, Stack } from "@mui/material";
import { useFormState } from "react-hook-form";

import { HubHookFormInput } from "../";

export const HubHookFormNumberInput = ({
  label = "",
  required = false,
  defaultValue,
  name,
  isNumber = true,
  ...rest
}) => {
  const [value, setValue] = useState(defaultValue);

  const { errors } = useFormState();

  const onChange = (e, newValue) => isNumber && setValue(parseInt(newValue));

  const errorMessage = errors[name]?.message;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      gap="10px"
      alignItems="center"
      width="200px"
    >
      <Stack width="100%">
        <HubHookFormInput
          name={name}
          label={label}
          required={required}
          defaultValue={value}
          onChange={onChange}
          isNumber={isNumber}
          fullWidth
          {...rest}
        />
        {errorMessage && (
          <FormHelperText error={!!errorMessage}>{errorMessage}</FormHelperText>
        )}
      </Stack>
    </Stack>
  );
};

export default HubHookFormNumberInput;
